import { useState } from "react";
import { ChevronRight } from "lucide-react";
import { api, formatAuthError } from "@/util";

export default function Login({ onAuthenticated }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError("");
    try {
      const response = await api.post("/auth/login", { email, password });
      onAuthenticated(response.data);
    } catch (err) {
      setError(formatAuthError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-screen">
      <div className="auth-art">
        <div className="auth-brand">
          <div className="brand-mark">V</div>
          <strong>voyage<span>360</span></strong>
        </div>
        <div className="auth-art-copy">
          <span className="eyebrow">SERENITY TRAVEL</span>
          <h1>Operasyonun,<br /><i>kontrol altında.</i></h1>
          <p>Turlarını, müşterilerini ve finansını tek güvenli alanda yönet.</p>
        </div>
      </div>
      <main className="auth-card">
        <span className="eyebrow">YÖNETİCİ GİRİŞİ</span>
        <h2>Tekrar hoş geldin</h2>
        <p className="auth-subtitle">Voyage360 çalışma alanına devam etmek için giriş yap.</p>
        <form onSubmit={submit} data-testid="login-form">
          <label>
            E-posta
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="admin@seyahatacentam.com"
              autoComplete="email"
              required
              data-testid="login-email-input"
            />
          </label>
          <label>
            Parola
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Parolanı gir"
              autoComplete="current-password"
              required
              data-testid="login-password-input"
            />
          </label>
          {error && (
            <div className="auth-error" role="alert" data-testid="login-error">
              {error}
            </div>
          )}
          <button className="primary-button auth-submit" type="submit" disabled={loading} data-testid="login-submit-button">
            {loading ? "Giriş yapılıyor…" : "Giriş yap"}
            <ChevronRight size={16} />
          </button>
        </form>
        <small className="auth-note">Yalnızca yetkili ekip üyeleri giriş yapabilir.</small>
      </main>
    </div>
  );
}
